<script>
    export default {
        props: {
            seeDirectoryActions: Boolean,
            tree: Object,
            headline: {
                type: String,
                default() {
                    return __('scoop-os.categories.select_category')
                },
            },
        },
        data() {
            return {
                loading: false,
            }
        },
        created() {
            this.$nextTick(() => {
                $('#jstreeCategorySelector').jstree({
                    'core': {
                        'themes': {
                            'name': 'proton',
                            'responsive': true
                        },
                        'multiple': false,
                        'check_callback': true
                    }
                });
                $('#jstreeCategorySelector').on("changed.jstree", function (e, data) {
                    if (data.node) {
                        this.$emit('input', data.node.id);
                        this.$emit('categorySelected', data.node.id);

                        $("#category-selector").modal('hide');
                    }
                }.bind(this));
            });
        }
    }
</script>

<template>
    <span>

        <Lightbox
            id="category-selector"
            :headline="headline"
            class="inline m-r-sm"
            :large="true"
        >
            <a slot="open-template">
                <slot>
                    <i class="fa fa-pencil"></i>
                </slot>
            </a>
            <div slot="body" class="text-left">
                <div class="row">
                    <div class="col-sm-12">
                        <div id="jstreeCategorySelector">
                            <ul>
                                <tree-node
                                    class="jstree-open"
                                    :node="tree"
                                    :children-collapsed="false"
                                    :selected="[]"
                                    key="directory-selector-root"
                                ></tree-node>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div v-cloak slot="footer">
                <button type="button" class="btn btn-white" data-dismiss="modal">{{ __('scoop-os.common.close') }}</button>
            </div>
        </Lightbox>
    </span>
</template>
